const { parseStars } = require('./parseStars')

function getAverage(array, key) {
  return array
    ? array.reduce((a, b) => a + parseStars(b[key]) || 0, 0) / array.length
    : null
}

const sumArrayValues = values => {
  return values.reduce((p, c) => p + c, 0)
}

const weightedAverage = (factorsArray, weightsArray) => {
  return (
    sumArrayValues(
      factorsArray.map((factor, index) => factor * weightsArray[index])
    ) / sumArrayValues(weightsArray)
  )
}

module.exports = { getAverage, weightedAverage }
